import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import moment from "moment";
import { NotificationService } from "../../swaggerServices/api/notification.service";
import { NotificationArray } from "../../swaggerServices/model/notificationArray";
import { UserInfoService } from "./user-info.service";

export interface NotificationMessage {
  heading: string;
  message: string | string[];
  success: boolean;
  date: string;
}

@Injectable()
export class ClientNotificationService {
  $newMessage: Subject<NotificationMessage> = new Subject();

  constructor(private notificationService: NotificationService) {}

  appendMessage(heading: string, message: string | string[], success: boolean = false) {
    const newMessage = {
      heading,
      message,
      success,
      date: moment().format("MMMM Do YYYY, h:mm:ss a"),
    };
    this.$newMessage.next(newMessage);
  }

  connect(userInfo: UserInfoService ,lastReceivedNotificationId?: number): void {
    this.notificationService
      .getNotifications(lastReceivedNotificationId)
      .subscribe(
        (notifications: NotificationArray) => {
          if (!userInfo.isLoggedIn()) {
            userInfo.logout();
            return;
          }
          for (const n of notifications) {
            // NOTE(mike): This is back-to-front for header/message, don't ask questions.
            this.appendMessage(
              n.header,
              n.message,
              n.success
            );
          }
          const lastNotificationId = notifications.length
            ? notifications[notifications.length - 1].id
            : lastReceivedNotificationId;
          this.connect(userInfo, lastNotificationId);
        },
        e => {
          if (!userInfo.isLoggedIn()) {
            userInfo.logout();
            return;
          }
          setTimeout(() => {
            this.connect(userInfo, lastReceivedNotificationId);
          }, 15000);
        }
      );
  }
}
